(function() {
	// globals
	PM.Organization = {};

	// Debounce timer for subdomain validation
	PM.Organization._subdomainTimer = null;

	// app functions

	PM.Organization.renderOrganization = function() {
		// Compute current domain (strip existing subdomain)
		var hostname = window.location.hostname;
		var parts = hostname.split('.');
		var currentDomain;
		if (parts.length >= 3) {
			currentDomain = parts.slice(1).join('.');
		} else {
			currentDomain = hostname;
		}
		// Add port if non-standard
		if (window.location.port && window.location.port !== '80' && window.location.port !== '443') {
			currentDomain += ':' + window.location.port;
		}

		$.when(
			$.get('/api/organizations'),
			ejs.preloadTemplate('/app/config/organization/templates/organization.ejs'),
			ejs.preloadTemplate('/app/config/organization/templates/create-org-modal.ejs'),
			ejs.preloadTemplate('/app/config/organization/templates/delete-org-modal.ejs')
		).done(function(orgResult) {
			var org = orgResult[0];
			var contentHtml = ejs.rr('/app/config/organization/templates/organization.ejs', {
				org: org,
				currentDomain: currentDomain
			});
			PM.Config.renderSection('organization', contentHtml);
		});
	};

	// events

	// ─── Subdomain live validation ─────────────────────────────────────────

	$(document).on('input', '.js-org-subdomain', function() {
		var $input = $(this);
		var $feedback = $('.js-org-subdomain-feedback');
		var subdomain = $input.val().trim();

		// Clear previous timer
		if (PM.Organization._subdomainTimer) {
			clearTimeout(PM.Organization._subdomainTimer);
		}

		if (!subdomain) {
			$feedback.hide();
			return;
		}

		$feedback.show().text(i18next.t('Checking...')).removeClass('text-success text-danger').addClass('text-muted');

		PM.Organization._subdomainTimer = setTimeout(function() {
			$.get('/api/organizations/check-subdomain/' + encodeURIComponent(subdomain))
				.done(function(result) {
					if (result.valid) {
						$feedback.text('\u2713 ' + i18next.t('Subdomain is available.')).removeClass('text-muted text-danger').addClass('text-success');
					} else {
						$feedback.text('\u2717 ' + (result.message ? i18next.t(result.message) : i18next.t('Invalid subdomain.')))
							.removeClass('text-muted text-success').addClass('text-danger');
					}
				})
				.fail(function() {
					$feedback.hide();
				});
		}, 400);
	});

	// ─── Save organization ─────────────────────────────────────────────────

	$(document).on('submit', '.js-org-form', function(e) {
		e.preventDefault();

		var name = $('.js-org-name').val().trim();
		var subdomain = $('.js-org-subdomain').val().trim();

		if (!name && !subdomain) {
			new Notify({ status: 'error', text: i18next.t('Name is required.'), timeout: 3000 });
			return;
		}

		var data = {};
		if (name) data.name = name;
		if (subdomain) data.subdomain = subdomain;

		$.ajax({
			url: '/api/organizations',
			method: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify(data)
		}).done(function(response) {
			new Notify({ status: 'success', text: i18next.t('Organization saved.'), timeout: 3000 });

			// If subdomain changed, redirect to the new URL
			if (response.redirectUrl) {
				// Give the user a moment to see the success notification
				setTimeout(function() {
					window.location.href = response.redirectUrl;
				}, 1500);
			} else {
				PM.Organization.renderOrganization();
			}
		});
	});

	// ─── Create organization modal ─────────────────────────────────────────

	// Debounce timer for create subdomain validation
	PM.Organization._createSubdomainTimer = null;

	$(document).on('click', '.js-org-add', function(e) {
		e.preventDefault();

		// Compute current domain
		var hostname = window.location.hostname;
		var parts = hostname.split('.');
		var currentDomain;
		if (parts.length >= 3) {
			currentDomain = parts.slice(1).join('.');
		} else {
			currentDomain = hostname;
		}
		if (window.location.port && window.location.port !== '80' && window.location.port !== '443') {
			currentDomain += ':' + window.location.port;
		}

		var modalHtml = ejs.rr('/app/config/organization/templates/create-org-modal.ejs', {
			currentDomain: currentDomain
		});

		var $modal = $(modalHtml);
		$('body').append($modal);
		var bsModal = new bootstrap.Modal($modal[0], { backdrop: 'static', keyboard: false });
		bsModal.show();

		$modal.on('shown.bs.modal', function() {
			$modal.find('.js-create-org-name').focus();
		});

		$modal.on('hidden.bs.modal', function() {
			$modal.remove();
		});
	});

	$(document).on('input', '.js-create-org-subdomain', function() {
		var $input = $(this);
		var $feedback = $input.closest('.modal').find('.js-create-org-subdomain-feedback');
		var subdomain = $input.val().trim();

		if (PM.Organization._createSubdomainTimer) {
			clearTimeout(PM.Organization._createSubdomainTimer);
		}

		if (!subdomain) {
			$feedback.hide();
			return;
		}

		$feedback.show().text(i18next.t('Checking...')).removeClass('text-success text-danger').addClass('text-muted');

		PM.Organization._createSubdomainTimer = setTimeout(function() {
			$.get('/api/organizations/check-subdomain/' + encodeURIComponent(subdomain))
				.done(function(result) {
					if (result.valid) {
						$feedback.text('\u2713 ' + i18next.t('Subdomain is available.')).removeClass('text-muted text-danger').addClass('text-success');
					} else {
						$feedback.text('\u2717 ' + (result.message ? i18next.t(result.message) : i18next.t('Invalid subdomain.')))
							.removeClass('text-muted text-success').addClass('text-danger');
					}
				})
				.fail(function() {
					$feedback.hide();
				});
		}, 400);
	});

	$(document).on('click', '.js-create-org-save', function() {
		var $modal = $(this).closest('.js-create-org-modal');
		var $btn = $(this);
		var name = $modal.find('.js-create-org-name').val().trim();
		var subdomain = $modal.find('.js-create-org-subdomain').val().trim();

		if (!name) {
			new Notify({ status: 'error', text: i18next.t('Name is required.'), timeout: 3000 });
			return;
		}

		var data = { name: name };
		if (subdomain) data.subdomain = subdomain;

		$btn.prop('disabled', true);

		$.ajax({
			url: '/api/organizations',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(data)
		}).done(function(response) {
			new Notify({ status: 'success', text: i18next.t('Organization created.'), timeout: 3000 });
			setTimeout(function() {
				window.location.href = response.redirectUrl + 'plan';
			}, 1500);
		}).fail(function(xhr) {
			$btn.prop('disabled', false);
		});
	});

	// ─── Delete organization ────────────────────────────────────────────────

	$(document).on('click', '.js-org-delete', function() {
		var orgName = $('.js-org-name').val().trim();

		if (!orgName) {
			new Notify({ status: 'error', text: i18next.t('Cannot determine organization name.'), timeout: 3000 });
			return;
		}

		var modalHtml = ejs.rr('/app/config/organization/templates/delete-org-modal.ejs', {
			orgName: orgName
		});

		var $modal = $(modalHtml);
		$('body').append($modal);
		var bsModal = new bootstrap.Modal($modal[0], { backdrop: 'static', keyboard: false });
		bsModal.show();

		// Focus the confirmation input
		$modal.on('shown.bs.modal', function() {
			$modal.find('.js-delete-org-confirm-input').trigger('focus');
		});

		// Clean up on hide
		$modal.on('hidden.bs.modal', function() {
			$modal.remove();
		});

		// Enable/disable the delete button based on input match
		$modal.on('input', '.js-delete-org-confirm-input', function() {
			var typed = $(this).val().trim();
			var $btn = $modal.find('.js-delete-org-confirm-btn');
			$btn.prop('disabled', typed !== orgName);
		});

		// Confirm delete
		$modal.on('click', '.js-delete-org-confirm-btn', function() {
			var $btn = $(this);
			$btn.prop('disabled', true).html(
				'<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>' +
				i18next.t('Deleting...')
			);

			$.ajax({
				url: '/api/organizations',
				method: 'DELETE',
				contentType: 'application/json'
			}).done(function(response) {
				bsModal.hide();

				if (response.logout) {
					new Notify({
						status: 'info',
						text: i18next.t('Organization deleted. You will be redirected.'),
						timeout: 4000
					});
					setTimeout(function() {
						window.location.href = response.redirectUrl;
					}, 1500);
				} else {
					new Notify({
						status: 'success',
						text: i18next.t('Organization deleted.'),
						timeout: 3000
					});
					setTimeout(function() {
						window.location.href = response.redirectUrl;
					}, 1500);
				}
			}).fail(function(xhr) {
				bsModal.hide();
			});
		});
	});

	// app startup

	page('/config/organization', PM.Shell.routeWithPermission('view_organization', PM.Organization.renderOrganization));
})();
